/**
 * @file Tells a contract route's 2xx body holding only the contract's id from one holding the contract.
 * No failure path: every input gives a boolean, and an absent body is not id-only.
 */

export function isContractIdOnly(body: any): boolean {
  const keys = Object.keys(body || {});

  return keys.length === 1 && keys[0] === "id";
}
